// import './App.css';
import Header from './components/Header';
import Meme from './components/Meme';
import './components/style.css'


function App() {

  return (
    <div className="App">
      <Header />
      <Meme />
    </div>
  );
}

export default App;
